import React from 'react'
import PropTypes from 'prop-types'
import MarketProductSingleVariantField from 'domains/seller-market-product/molecules/single-variant-field'
import MarketProductMultipleVariantField from 'domains/seller-market-product/molecules/multiple-variant-field'

const propTypes = {
  variants         : PropTypes.array,
  measurementProps : PropTypes.object,
  disabledFields   : PropTypes.object,
  arrayHelpers     : PropTypes.object
}

/**
 * Variant field to create market product.
 * return market product single variant field if the dimension is less than 1
 * otherwise, return the multiple variant field
 * @param {object} arrayHelpers - Formik field array helper
 * @param {bool} disabledFields - consist of disabled fields
 * @param {array} variants - Formik value variants
 * @param {object} measurementProps - Measurement props. contain
 *   - parentName
 *   - productSize
 *   - measurementAttributes
 */
const SellerMarketProductVariantField = ({
  arrayHelpers,
  disabledFields,
  variants,
  ...measurementProps
}) => {
  // Add guard to return null if dimension still empty
  if (!variants) return null

  return (
    variants.length <= 1
      ? (
        <MarketProductSingleVariantField
          disabledFields={ disabledFields }
          { ...measurementProps }
        />
      )
      : (
        <MarketProductMultipleVariantField
          { ...measurementProps }
          disabledFields={ disabledFields }
          variants={ variants }
          arrayHelpers={ arrayHelpers }
        />
      )
  )
}

SellerMarketProductVariantField.propTypes = propTypes

export default SellerMarketProductVariantField
